/**
 * Fullscreen for any element, without ever calling a method the browser lacks. iPhone Safari
 * only fullscreens a <video>: `requestFullscreen` is undefined on a div there (TypeError seen on
 * iOS 18.7), and `document.fullscreenEnabled` is false. Older WebKit exposes the prefixed API.
 */

interface PrefixedDocument {
  fullscreenEnabled?: boolean;
  webkitFullscreenEnabled?: boolean;
}

interface PrefixedElement {
  requestFullscreen?: () => Promise<void>;
  webkitRequestFullscreen?: () => void;
}

/** Whether the page may put an element in fullscreen: the button shows only then. */
export function canEnterFullscreen(doc: PrefixedDocument | undefined = typeof document === 'undefined' ? undefined : document): boolean {
  return doc?.fullscreenEnabled === true || doc?.webkitFullscreenEnabled === true;
}

/** Puts the element in fullscreen if the browser can; a refusal is swallowed, never thrown. */
export function enterFullscreen(element: PrefixedElement | null): void {
  if (!element) return;
  if (typeof element.requestFullscreen === 'function') {
    void element.requestFullscreen().catch(() => undefined);
  } else if (typeof element.webkitRequestFullscreen === 'function') {
    element.webkitRequestFullscreen();
  }
}
